export default {
  Min: 0,
  Max: 99999999999999,
  NegativeMax: -99999999999999,
};
